<template>
  <div>
    <md-switch
      v-model="newValue"
      :disabled="disabled"
    >
      {{ label }}
    </md-switch>
  </div>
</template>

<script>
export default {
  name: 'XSwitch',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValue: {
      get() {
        return this.value
      },
      set(val) {
        return this.$emit('update', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-switch {
  display: flex;
  align-items: center;
}
</style>
